<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>
      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="110px" >         
          <el-row>
            <el-col :span="15">
              <el-form-item :label="$t('field.customerNo')" required>  
                <el-select v-model="customer" :placeholder="$t('msg.pleaseSelect')" multiple @change="changeCust()" style="width:100%">
                  <el-option v-for="item in customerOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>   
            <el-col :span="9">
              <el-form-item :label="$t('field.timeRange')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;" @change="changeDate()"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;" @change="changeDate()"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('field.failureType')" required>          
                <el-select  :placeholder="$t('msg.pleaseSelect')" style="width:98%" v-model="failureType" @change="changeFailureType()" >
                  <el-option v-for="v in failureTypeOpts"  :key="v"  :label="v" :value="v"></el-option>
                </el-select> 
              </el-form-item>
            </el-col>
          </el-row> 
        <el-row style="padding-bottom:10px"> 
          <el-col>   
            <el-button type="warning" icon="el-icon-download" @click="exportExcel" ></el-button>  
          </el-col>
        </el-row> 
 
        <el-row>       
          <el-table :data="tableData.data" id="dtlTable" style="width:100%" >          
            <el-table-column  v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" width="150" :key="i" :fixed="i==0">                 
              <template slot-scope="scope"> <span>{{ scope.row[v.field] }} </span> </template>
            </el-table-column>
          </el-table>
        </el-row>

        <div v-for="index in charData.type.length" style="width:80%">
          <h2>{{charData.type[index-1]}}</h2>
          <HorizontalBar :chartData="charData.data[index-1]" :options="options" v-if="true"  style="position:relative;height:300px" class="chartCls"></HorizontalBar>
        </div>
        

      </el-form>
    </el-main>
  </div>
</template>

<script>
import Table from '../components/FuzzySearchTable'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindAllCustList, apiFeedbackStatByFailureTypeWithRma } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import HorizontalBar from '../components/chart/HorizontalBarChart.js'

export default {
  name: 'feedbackStatByFailureTypeWithRma',
  data() {    
    return {   
      sdate: '',
      edate: '',
      customer: '',
      customerOpts:[],
      failureType:'Level1',
      failureTypeOpts:['Level1','Level2','Level3'],  
      tableData: {
        columns:[],
        data:[]       
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
					display: false
				},
        scales: {
					yAxes: [{
						ticks: {
                // max: 25000,
                min: 0,
                // stepSize: 1,
                beginAtZero: true,
                padding: 5, 
            },
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
      },
      charData: {
        type:[],
        data:[],
        id:['char1','char2','char3','char4','char5']
      }
    };
  }, 
  components: {
    Breadcrumb,
    Table,
    HorizontalBar    
  },
  mounted() {

    this.edate = new Date();  
    this.sdate = new Date(this.edate.getFullYear()+'-01-01');
   
    apiFindAllCustList({ headers: authHeader()}).then((response) => { 
      this.customerOpts = [];     
      var tempCustArr = [];  
      if(response.data != null && response.data.length >0){       
        response.data.forEach((item, index) => {   
          this.customerOpts.push({ value: item.key, label: item.value, desc: item.value2 });
          tempCustArr.push(item.key);
        });    
        this.customer = tempCustArr;  
         this.findData();
      }
    }).catch((err) => {
      console.log(err);
    });
      
  },
  methods: {
  
    findData(){      
      var sdate = '', edate = '', custNos = '';
      if(this.customer.length > 0){
        if(this.sdate != null && this.sdate != ''){        
          sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
        }
        if(this.edate != null && this.edate != ''){        
          edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
        }
        this.customer.forEach((item, index) => {   
          custNos += item+';';
        });

        apiFeedbackStatByFailureTypeWithRma({ headers: authHeader(), sdate : sdate, edate : edate, custNos:custNos, failureType:this.failureType}).then((response) => { 
          this.tableData.columns = [];
          this.tableData.columns.push({ field: 'type', title: 'Case Type'});  
           let custNos = [];
          Object.entries(response.data[0]).forEach(([key, value]) => {
            if(key != 'type' && key != 'typeSum'){
              custNos.push( key.replace('cust_',''));
            }
          });  
          for (var i = 0; i < custNos.length; i++) {  
            let custName = this.customerOpts.find(function(r){
              return r.value == custNos[i];
            });
            this.tableData.columns.push({ field: 'cust_'+custNos[i], title: custName.desc });    
          }  

          this.tableData.columns.push({ field: 'typeSum', title: 'Summary'});  
          this.tableData.data = response.data;

          this.generateChart();

        
        }).catch((err) => {
          console.log(err);
        });
      }else{
        this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
      }     
    },
    changeCust(){
      this.findData();
    },
    changeFailureType(){
      this.findData();
    },
    changeDate(){
      this.findData();
    },
    generateChart(){     
      this.charData.data = [];
      this.charData.type = [];
      this.tableData.data.forEach((item, index) => { 
        if(item.type!= 'Summary'){
          this.charData.type.push(item.type);          
          let tempData = new Object();
          tempData.labels = [];
          tempData.datasets = [{data:[], backgroundColor:[], label: 'Data One',
                barThickness: 15,  // number (pixels) or 'flex'
                maxBarThickness: 20, // number (pixels)
          }];
          
          let tempMap = [];          
          for (const [key, value] of Object.entries(item)) {
            if(key.startsWith('cust') && item[key] != '0'){ 
              tempMap.push({'field':key, 'value':value});
            }
          }
          
          //由大到小排序
          tempMap = tempMap.sort(function (a, b) {
            return Number(a.value) < Number(b.value) ? 1 : -1;
          });
          var colorArr = this.gradientColor('#da5656','#9BC293',tempMap.length);     

          
          tempMap.forEach((custInfo, i) => { 
            let custName = this.tableData.columns.find(function(rec){
              return rec.field == custInfo.field;
            });
            tempData.labels.push(custName.title);
            tempData.datasets[0].data.push(Number(custInfo.value)); 
            tempData.datasets[0].backgroundColor.push(colorArr[i]);                   
          });          
          this.charData.data.push(tempData);           
        }
      });

      setTimeout(( () => {
        this.charData.data.forEach((d, i) => { 
          document.getElementsByClassName('chartCls')[i].style.height = d.datasets[0].data.length*45+'px';
        });
      }), 500);  
    },  
    exportExcel(){
      this.$nextTick(function () {
        // 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
        var fix = document.querySelector('.el-table__fixed');
        var wb;
        if (fix) {
          wb = XLSX.utils.table_to_book(document.querySelector('#dtlTable').removeChild(fix));
          document.querySelector('#dtlTable').appendChild(fix);
        } else {
          wb = XLSX.utils.table_to_book(document.querySelector('#dtlTable'));
        }
        let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
        try {
            FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), '匯出'+CommonUtil.dateFormat(new Date()).replace(':','_')+'.xlsx')
        } catch (e) {
            if (typeof console !== 'undefined') console.log(e, wbout)
        }           
      })
    },
    gradientColor(startColor,endColor,step){
      let startRGB = this.colorRgb(startColor);//转换为rgb数组模式
      let startR = startRGB[0];
      let startG = startRGB[1];
      let startB = startRGB[2];
      let endRGB = this.colorRgb(endColor);
      let endR = endRGB[0];
      let endG = endRGB[1];
      let endB = endRGB[2];
      let sR = (endR-startR)/step;//总差值
      let sG = (endG-startG)/step;
      let sB = (endB-startB)/step;
      let  colorArr = [];
      for(var i=0;i<step;i++){
        //计算每一步的hex值
        var hex = this.colorHex('rgb('+parseInt((sR*i+startR))+','+parseInt((sG*i+startG))+','+parseInt((sB*i+startB))+')');
        colorArr.push(hex);
      }
      return colorArr;
    },
    // 将hex表示方式转换为rgb表示方式(这里返回rgb数组模式)
    colorRgb (sColor){
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var sColor = sColor.toLowerCase();
      if(sColor && reg.test(sColor)){
      if(sColor.length === 4){
        var sColorNew = "#";
        for(var i=1; i<4; i+=1){
        sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
        }
        sColor = sColorNew;
      }
      //处理六位的颜色值
      var sColorChange = [];
      for(var i=1; i<7; i+=2){
        sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));
      }
      return sColorChange;
      }else{
      return sColor;
      }
    },
    // 将rgb表示方式转换为hex表示方式
    colorHex (rgb){
      var _this = rgb;
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      if(/^(rgb|RGB)/.test(_this)){
      var aColor = _this.replace(/(?:(|)|rgb|RGB)*/g,"").split(",");
      var strHex = "#";
      for(var i=0; i<aColor.length; i++){
        var hex = Number(aColor[i]).toString(16);
        hex = hex<10 ? 0+''+hex :hex;// 保证每个rgb的值为2位
        if(hex === "0"){
        hex += hex;
        }
        strHex += hex;
      }
      if(strHex.length !== 7){
        strHex = _this;
      }
      return strHex;
      }else if(reg.test(_this)){
      var aNum = _this.replace(/#/,"").split("");
      if(aNum.length === 6){
        return _this;
      }else if(aNum.length === 3){
        var numHex = "#";
        for(var i=0; i<aNum.length; i+=1){
        numHex += (aNum[i]+aNum[i]);
        }
        return numHex;
      }
      }else{
      return _this;
      }
    }
  }
};
</script>
